import { GameState, InningsState } from '../types/game';
import { 
  formatOversDisplay, 
  formatRunRate, 
  calculateWicketsRemaining,
  calculateProjectedScore,
  calculateTarget,
  calculateRequiredRunRate
} from './gameLogic';

export interface DisplayValues {
  oversDisplay: string;
  currentScore: string;
  wicketsRemaining: number;
  runRate: string;
  projected: string;
  isSecondInnings: boolean;
  showChaseTarget: boolean;
  targetRuns: number;
  ballsRemaining: number;
  requiredRunRate: string;
  showLastManStands: boolean;
  lastManBatterName: string;
}

export function calculateDisplayValues(gameState: GameState): DisplayValues {
  const currentInnings = gameState.currentInnings === 1 ? gameState.innings1 : gameState.innings2!;
  const oversDisplay = formatOversDisplay(currentInnings.totalBalls, gameState.matchSettings.ballsPerOver);
  const currentScore = `${currentInnings.runs}/${currentInnings.wicketsDown}`;
  const wicketsRemaining = calculateWicketsRemaining(currentInnings.wicketsDown, gameState.matchSettings.numberOfPlayers);
  const runRate = formatRunRate(currentInnings.runs, currentInnings.totalBalls, gameState.matchSettings.ballsPerOver);

  const projected = gameState.currentInnings === 1 
    ? calculateProjectedScore(currentInnings, gameState.matchSettings).toString()
    : calculateTarget(gameState.innings1).toString();

  const isSecondInnings = gameState.currentInnings === 2;

  // Chase target calculation
  const showChaseTarget = isSecondInnings && gameState.innings2;
  const targetRuns = showChaseTarget ? calculateTarget(gameState.innings1) - gameState.innings2.runs : 0;
  const ballsRemaining = showChaseTarget 
    ? (gameState.matchSettings.oversPerInnings * gameState.matchSettings.ballsPerOver) - gameState.innings2.totalBalls 
    : 0;
  const requiredRunRate = calculateRequiredRunRate(gameState);

  // Last Man Stands status
  const showLastManStands = currentInnings.isLastManStands;
  const lastManBatterName = currentInnings.batter1.name !== "Last Man Stands" 
    ? currentInnings.batter1.name 
    : currentInnings.batter2.name;

  return {
    oversDisplay,
    currentScore,
    wicketsRemaining,
    runRate,
    projected,
    isSecondInnings,
    showChaseTarget,
    targetRuns,
    ballsRemaining,
    requiredRunRate,
    showLastManStands,
    lastManBatterName,
  };
}